import cx from 'classnames'
import { MdOutlineCheckBox } from 'react-icons/md'
import { useSlate } from 'slate-react'

import { insertInlineCheckbox, isBlockTypeActive, isInlineCheckboxFeasible } from '../../util'

export function InlineButtonInSelect (): JSX.Element {
  const editor = useSlate()
  const isActive = isBlockTypeActive(editor, 'checkbox')
  const isFeasible = isInlineCheckboxFeasible(editor)

  return (
    <button
      type='button'
      className={cx('py-3 px-2 rounded-sm transition-colors flex flex-row gap-3 w-full disabled:text-[#aaaaaa] disabled:cursor-not-allowed  hover:bg-gray-100', {
        'text-primary': isActive
      })}
      onMouseDown={event => {
        event.preventDefault()
        insertInlineCheckbox(editor)
      }}
      disabled={!isFeasible}
      title='Inline checkbox'
    >
      <MdOutlineCheckBox size='1.2rem' />
      Inline checkbox
    </button>
  )
}
